import { render, staticRenderFns } from "./DesignerFieldInputs.vue?vue&type=template&id=0ed6570e&scoped=true&"
import script from "./DesignerFieldInputs.vue?vue&type=script&lang=js&"
export * from "./DesignerFieldInputs.vue?vue&type=script&lang=js&"
import style0 from "./DesignerFieldInputs.vue?vue&type=style&index=0&id=0ed6570e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed6570e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed6570e')) {
      api.createRecord('0ed6570e', component.options)
    } else {
      api.reload('0ed6570e', component.options)
    }
    module.hot.accept("./DesignerFieldInputs.vue?vue&type=template&id=0ed6570e&scoped=true&", function () {
      api.rerender('0ed6570e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ImportMappings/DesignerFieldInputs.vue"
export default component.exports